import type { Option } from '@comparit/core';
import { HausratSchadenart } from '../../../interfaces';

export const schadenartOptions: Option<HausratSchadenart>[] = [
  { label: 'Feuer', value: HausratSchadenart.Feuer },
  { label: 'Einbruchdiebstahl', value: HausratSchadenart.Einbruchdiebstahl },
  { label: 'Leitungswasser', value: HausratSchadenart.Leitungswasser },
  { label: 'Sturm/Hagel', value: HausratSchadenart.Sturm },
  { label: 'Elementar', value: HausratSchadenart.Elementar },
  { label: 'Starkregen', value: HausratSchadenart.Starkregen },
  { label: 'Glas', value: HausratSchadenart.Glas },
  { label: 'Fahrraddiebstahl', value: HausratSchadenart.Fahrraddiebstahl },
];
